export const bookingEstimationGetErrorMessage = ({ errorList, intl }) => {
  if (
    "object" === typeof errorList &&
    null !== errorList &&
    Object.keys(errorList).length > 0
  ) {
    if (errorList.period_state || errorList.state || errorList.room_setting) {
      return intl.formatMessage({
        defaultMessage: "Ces dates ne sont pas disponibles.",
      });
    }

    if (errorList.checkin || errorList.checkout) {
      if (
        Array.isArray(errorList.checkin) ||
        Array.isArray(errorList.checkout)
      ) {
        return intl.formatMessage({
          defaultMessage:
            "La date d'entrée ne peut pas être supérieure à la date de sortie.",
        });
      } else {
        return intl.formatMessage({
          defaultMessage:
            "La date d'entrée ne peut pas être supérieure à la date de sortie.",
        });
      }
    }

    if (
      errorList.checkin_date ||
      errorList.checkout_date ||
      errorList.selling_mode ||
      errorList.tourist_tax ||
      errorList.min_offset ||
      errorList.min_stay ||
      errorList.min_offset_booking
    ) {
      return intl.formatMessage({
        defaultMessage:
          "Votre séjour nécessite une vérification des disponibilités. Nous vous invitons à nous contacter. Une réponse vous sera fournie dans les meilleurs délais.",
      });
    }

    if (errorList.capacity_exceeded || errorList.babies) {
      return intl.formatMessage({
        defaultMessage: "Capacité maximale du bien dépassée.",
      });
    }

    if (errorList.mode) {
      return intl.formatMessage({
        defaultMessage: "Hébergement non réservable en ligne.",
      });
    }

    if (errorList.pets) {
      return intl.formatMessage({
        defaultMessage: "Nombre d’animaux invalide.",
      });
    }

    if (errorList.adults) {
      return intl.formatMessage({
        defaultMessage: "Le nombre de voyageur choisi n’est pas autorisé.",
      });
    }

    if (errorList.firstname) {
      return intl.formatMessage({
        defaultMessage: "Le prénom n’est pas valide.",
      });
    }

    if (errorList.lastname) {
      return intl.formatMessage({
        defaultMessage: "Le nom de famille n’est pas valide.",
      });
    }

    if (errorList.gender) {
      return intl.formatMessage({
        defaultMessage: "Le genre n’est pas valide.",
      });
    }

    if (errorList.password) {
      return intl.formatMessage({
        defaultMessage: "Le mot de passe n’est pas valide.",
      });
    }

    // Retourne la valeur de la première clé trouvée dans l'erreur.
    return errorList?.[Object.keys(errorList)[0]]?.[0];
  }
};

export default bookingEstimationGetErrorMessage;
